<template>
  <!-- 提出物承認申請画面 -->
  <CCard>
    <CCardHeader>
      <CRow>
        <CCol>
          <h2>承認申請一覧</h2>
        </CCol>
      </CRow>
    </CCardHeader>
    <CCardBody>
      <p>承認済み以外の提出物一覧です。</p>
      <p style="color: red;" v-for="error in message" :key="error">{{ error }}</p>
      <div v-if="items.length">
        <div class="table-responsive">
          ※複数プロジェクトに所属している場合は代表プロジェクト１つを表示しています。
          <table class="table table-bordered">
            <thead>
              <tr>
                <th style="text-align: center;" width="50">
                  <input type="checkbox" v-model="selectAll" @change="toggleSelectAll" />
                </th>
                <th scope="col" width="80px" nowrap>ステータス</th>
                <th scope="col" width="100px" nowrap>提出物</th>
                <th scope="col" width="100px" nowrap>年月</th>
                <th scope="col" width="100px" nowrap>プロジェクト名</th>
                <th scope="col" width="100px" nowrap>承認者</th>
                <th scope="col" nowrap>差戻し理由</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in items" :key="item.id">
                <td style="text-align: center;">
                  <input type="checkbox" :value="item" v-model="selectedItems" />
                </td>
                <td :style="statusColor(item.status)" nowrap>{{ item.status }}</td>
                <td nowrap>{{ item.document_name }}</td>
                <td nowrap>{{ item.year_month }}</td>
                <td nowrap>{{ item.project_name }}</td>
                <td nowrap>
                  <select 
                  class="custom-select" 
                  v-model="selectedNames[index]" 
                  @change="updateApprover(index)"
                  style="width: 120px"
                  >
                    <option v-for="option in options" :value="option.id" :key="option.id"
                    :disabled="item.status == '承認待ち' && option.id != key"
                    >{{ option.name }}
                  </option>
                  </select>
                </td>
                <td class="linefeed">{{ item.comment }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <CRow v-if="buttonMessage.length">
          <CCol>
            <p style="color: red;" v-for="error in buttonMessage" :key="error">{{ error }}</p>
          </CCol>
        </CRow>
        <CRow>
          <CCol>
            Slack用補足コメント ※Google Drive提出物との差異がある等、補足事項あれば記入して下さい。
            <CTextarea rows="5" v-model="sns_message"></CTextarea>
          </CCol>
        </CRow>
        <br/>
        <CRow class="justify-content-center">
          <CCol xs="auto">
            <div class="d-flex justify-content-center gap-3 flex-wrap text-nowrap">
              <button 
                :loading="loading" 
                v-if="!showButton" 
                class="btn btn-danger" 
                @click="excludeFromList">
                  申請リストから除外
              </button>
              <button 
                :loading="loading" 
                v-if="!showButton" 
                class="btn btn-danger" 
                @click="applyCancel">
                  申請取消
              </button>
              <button 
                :loading="loading" 
                v-if="!showButton" 
                class="btn btn-primary" 
                @click="apply">
                  申請
              </button>
            </div>
          </CCol>
        </CRow>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from "axios";
import ConstList from "./../ConstList";
import SubmissionConst from "./ConstList";
export default {
  name: "ReportList",
  data() {
    return {
      items: [],
      message: [],
      sns_message: "",
      buttonMessage: [], // ボタン押下イベントのメッセージ
      selectedItems: [], // 選択されたアイテムのIDを保持
      selectAll: false, // 全選択チェックボックスの状態
      showButton: false, // 申請ボタン・取消ボタンの表示非表示
      options: [],
      selectedNames: [],
      departmentHeadId: null,
    };
  },
  // DBから各種情報を取得
  mounted: function() {{
    axios
      .get(process.env.VUE_APP_API_ORIGIN + "/submission/list")
      .then(response => {
        this.items = response.data;

          // ステータス優先度マップ
        const statusPriority = {
          [ConstList.REJECT]: 4,          // 差戻し
          [ConstList.UNSUBMITTED]: 3,     // 未申請
          [ConstList.APPROVAL_PENDING]: 2,// 承認待ち
          [ConstList.APPROVAL]: 1         // 承認済み
        };

        // 降順ソート（priorityの大きいものが上に来る）
        this.items.sort((a, b) => {
          return (statusPriority[b.status] || 0) - (statusPriority[a.status] || 0);
        });

        this.applyDefaultApprover()
        if (this.items.length === 0) {
          this.message.push(ConstList.EMPTY_REQUEST);
          // データがない場合はボタンを非表示に設定
          this.showButton = true;
        } 
      })
      .catch(error => {
        axios
        .get(
          `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
        )
        .then(() => {
          alert(ConstList.SYSTEM_ERROR);
        })
        .catch(() => {
          alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
        });
      });
    }
    {
      axios
        .get((process.env.VUE_APP_API_ORIGIN) + '/manager')
        .then(response => {
          this.options = Array.isArray(response.data) ? response.data : []

          const head = this.options.find(o => o && o.department_head_flg === true)
          this.departmentHeadId = head ? head.id : null

          this.applyDefaultApprover()
        })
        .catch(error => {
          axios
          .get(
            `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
          )
          .then(() => {
            alert(ConstList.SYSTEM_ERROR);
          })
          .catch(() => {
            alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
          })
        })
    }
  },
  methods: {
    // 申請
    apply: function() {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_APPLY);
        this.messagehideDelay(3000);
        return;
      }
      // 選択したアイテムに承認待ちがあった場合
      const selectSatus = this.selectedItems.filter(
        item => item.status == ConstList.APPROVAL_PENDING);
      if(selectSatus.length > 0){
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_APPLY_ALREADY);
        this.messagehideDelay(4000);
        return;
      }

      // 送信するアイテムのidを取得する
      const params = this.selectedItems.map(item => ({
        id: item.id,
        document_type: item.document_type,
        approver_user_id: item.approver_user_id === null ? item.user_id : item.approver_user_id,
        sns_message: this.sns_message,
        approval_type: item.approval_type,
        year_month: item.year_month,
      }));
    this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を申請してもよろしいですか？"
          },
          {
            okText: "はい",
            cancelText: "キャンセル"
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/register",params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json"
                }
              }
            )
            .then(() => {
              alert(SubmissionConst.APPLY_MESSAGE);
              window.location.reload();
            })
            .catch(error => {
              axios
              .get(
                `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
              )
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(function() {
          // キャンセル
        });
    },
    // 申請取消
    applyCancel: function() {
      // 1件も選択されていない場合
      if (this.selectedItems.length === 0) {
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_APPLY_CANCEL);
        this.messagehideDelay(3000);
        return;
      }
      // 選択したアイテムに未申請または差戻があった場合
      const selectSatus = this.selectedItems.filter(
        item => item.status == ConstList.UNSUBMITTED || item.status ==  ConstList.REJECT);
      if(selectSatus.length > 0){
        this.buttonMessage.push(SubmissionConst.ERROR_MESSAGE_APPLY_CANCEL_ALREADY);
        this.messagehideDelay(4000);
        return;
      }
      const params = this.selectedItems.map(item => ({
        id: item.id,
        document_type: item.document_type,
        approver_user_id: item.approver_user_id === null ? item.user_id : item.approver_user_id,
        sns_message: this.sns_message,
        approval_type: item.approval_type,
        year_month: item.year_month,
      }));
      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を申請取消してもよろしいですか？"
          },
          {
            okText: "はい",
            cancelText: "キャンセル"
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/unRegister",params,
              {
                headers: {
                  // content-type指定。@requestBodyでサーバ側にてバインドするため。
                  "Content-Type": "application/json"
                }
              }
            )
            .then(() => {
              alert(SubmissionConst.CANCEL_MESSAGE);
              window.location.reload();
            })
            .catch(error => {
              axios
              .get(
                `${process.env.VUE_APP_API_ORIGIN}/error/frontError/${error}`
              )
              .then(() => {
                alert(ConstList.SYSTEM_ERROR);
              })
              .catch(() => {
                alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
              });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(function() {
          // キャンセル
        });
    },
    // 申請除外
    excludeFromList: function() {
      if (this.selectedItems.length === 0) {
        this.buttonMessage.push("提出物を選択してください。");
        this.messagehideDelay(3000);
        return;
      }

      // 休暇関連（有給・代休・特休）は除外不可
      const isVacation = (it) => {
      const dt = String(it.document_type ?? "").padStart(2, "0"); // '5'→'05' に統一
      const name = String(it.document_name ?? "");
      return dt === "05" || /有給|代休|特休/.test(name);
    };
    if (this.selectedItems.some(isVacation)) {
      this.$dialog.alert(
        {
          title: "情報",
          body: "休暇関連の提出物はこの画面からは除外できません。休暇申請の一覧画面で削除してください。"
        },
        { okText: "確認" }
      );
      return; // ここで処理終了（除外しない）
    }

      const params = this.selectedItems.map(item => ({
        id: item.id,
        document_type: item.document_type,
        approver_user_id: item.approver_user_id === null ? item.user_id : item.approver_user_id,
        sns_message: this.sns_message,
        approval_type: item.approval_type,
      }));

      this.$dialog
        .confirm(
          {
            title: "確認",
            body: "選択した提出物を申請リストから除外してもよろしいですか？（再度個別に更新保存することで再リストされます）"
          },
          {
            okText: "はい",
            cancelText: "キャンセル"
          }
        )
        .then(() => {
          this.loading = true;
          axios
            .post(
              process.env.VUE_APP_API_ORIGIN + "/submission/exclude", params,
              { headers: { "Content-Type": "application/json" } }
            )
            .then(() => {
              alert("申請リストから除外しました。");
              window.location.reload();
            })
            .catch(error => {
              axios
                .get(`${process.env.VUE_APP_API_ORIGIN}/error/frontError/${encodeURIComponent(error.message || String(error))}`)
                .then(() => {
                  alert(ConstList.SYSTEM_ERROR);
                })
                .catch(() => {
                  alert(ConstList.SYSTEM_COMMUNICATION_ERROR);
                });
            })
            .finally(() => {
              this.loading = false;
            });
        })
        .catch(() => {
          // キャンセル時は何もしない
        });
    },
    // 承認状態の識別
    statusColor(status) {
      switch (status) {
        case ConstList.REJECT:
        case ConstList.UNSUBMITTED: 
          return { color: 'red' };
        case ConstList.APPROVAL_PENDING:
          return { color: 'orange' };
        case ConstList.APPROVAL:
          return { color: 'green' };
        default:
          return {};
      }
    },
    // ヘッダのチェックボックスを選択した場合
    toggleSelectAll() {
      if (this.selectAll) {
        // 全選択チェックボックスがチェックされた場合、全てのアイテムにチェック
        this.selectedItems = this.items.map(item => item);
      } else {
        this.selectedItems = [];
      }
    },
    // メッセージの表示時間設定
    messagehideDelay: function(delay) {
      setTimeout(() => {
        this.buttonMessage = [];
      }, delay);
    },
    // 承認者変更の時
    updateApprover: function(index) {
      this.items[index].approver_user_id = this.selectedNames[index];
    },
    applyDefaultApprover: function () {
      if (!Array.isArray(this.items) || this.items.length === 0) return

      const headId = Number(this.departmentHeadId)
      const hasHead = Number.isFinite(headId) && this.options.some(o => Number(o.id) === headId)

      this.selectedNames = this.items.map((item) => {
        if (item.approver_user_id != null) return item.approver_user_id
        if (hasHead) return headId
        return item.user_id   // 既存ロジック（プロジェクトリーダ）
      })
    },
  },
  watch: {
    selectedItems: function() {
      // 選択されたアイテムの数がテーブルのアイテム数と一致しない場合、全選択チェックボックスをfalseにする(外す)
      this.selectAll = this.selectedItems.length === this.items.length;
    }
  }
};
</script>

<style scoped>
td {
  word-break: break-all;
  vertical-align: middle;
  white-space: nowrap;
  padding-top: 0;
  padding-bottom: 0;
}
</style>
